import { Fragment, PropsWithChildren, useEffect, useState } from "react";
import { toast } from "shared/providers/toast/toast.package";
import { useHistory, useParams } from "shared/providers/router/router.package";
import * as Sentry from "shared/providers/sentry/sentry.package";

import { useReactiveVar } from "shared/providers/apollo/apollo.package";
import {
  portfolioVar,
  resetPortfolioVar,
} from "../../common/apollo/vars/portfolio.var";
import { portfolioSwitchingVar } from "../../common/apollo/vars/portfolio-switching.var";
import { resetDockVar } from "../../common/apollo/vars/dock.var";
import { resetGlobalModalVar } from "../../common/apollo/vars/global-modal.var";

import { Spinner } from "shared/components/spinner";

import { useGetPortfolioLazyQuery } from "../../generated/graphql";

const PortfolioProtectedRoute = ({ children }: PropsWithChildren) => {
  const { id } = useParams<{ id: string }>();

  const history = useHistory();

  const portfolioSwitching = useReactiveVar(portfolioSwitchingVar);

  const [portfolioSet, setPortfolio] = useState(false);

  const [getData] = useGetPortfolioLazyQuery({
    onCompleted: (data) => {
      portfolioVar({
        id: data.getPortfolio.id,
        title: data.getPortfolio.title,
        url: data.getPortfolio.url,
        translation: data.getPortfolio.translation
          ? {
              id: data.getPortfolio.translation.id,
              title: data.getPortfolio.translation.title,
            }
          : null,
        active: data.getPortfolio.active,
        logo: data.getPortfolio.logo || null,
        background: data.getPortfolio.background || null,
      });

      Sentry.setContext("portfolioInformation", {
        id: data.getPortfolio.id,
        url: data.getPortfolio.url,
        name: data.getPortfolio.title,
      });

      setPortfolio(true);
    },
    onError: (err) => {
      toast.error(err.message);

      history.push("/portfolios");
    },
  });

  useEffect(() => {
    return () => {
      resetDockVar();
      resetGlobalModalVar();
      resetPortfolioVar();
    };
  }, []);

  useEffect(() => {
    setPortfolio(false);

    if (!portfolioSwitching) {
      Sentry.setContext("portfolioInformation", {
        id: id,
        url: null,
        name: null,
      });

      getData({
        fetchPolicy: "no-cache",
        variables: {
          id,
        },
      });
    }

    return () => {
      Sentry.setContext("portfolioInformation", {
        id: null,
        url: null,
        name: null,
      });
    };
  }, [id, getData, portfolioSwitching]);

  if (portfolioSwitching || !portfolioSet) {
    return <Spinner $height="100vh" />;
  }

  return <Fragment>{children}</Fragment>;
};

export default PortfolioProtectedRoute;
